import { takeEvery, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SHOW_EXCHANGE_MODAL } from '../actions';
import { featureFlagsSelector } from '../shared/selectors/config';

export default function* saga() {
  if (typeof window === 'undefined') {
    return;
  }

  const { newConversionModal }: ReturnType<typeof featureFlagsSelector> = yield select(
    featureFlagsSelector
  );

  if (!newConversionModal) {
    return;
  }

  yield takeEvery(SHOW_EXCHANGE_MODAL, function* () {
    if (window.location.pathname.match(/\/conversion/)) {
      const base = window.location.pathname.replace(/\/conversion/g, '');
      yield put(push(base));
      yield new Promise((resolve) => setTimeout(resolve, 0));
      yield put(push(`${base}/conversion`.replace(/\/{2,}/g, '/')));
      return;
    }
    const pathname = `${window.location.pathname}/conversion`.replace(/\/{2,}/g, '/');
    yield put(push(pathname));
  });
}
